module.exports = __webpack_public_path__ + "img/no_data.ab2fe84e.png";